export const userSettingsQueryKeys = {
  LIMIT_DEVICES_LIST: 'limitDevicesList',
  PASSWORD_POLICY: 'passwordPolicy',
  TWO_FA_STATUS: 'twoFaStatus',
  QR_CODE_2FA: 'qrCode2fa',
  USER_PROFILE_PICTURE: 'userProfilePicture',
  NEW_SMS_CODE_2FA: 'newSmsCode2fa'
}

export const userSettingsMutationKeys = {
  PREPARE_2FA: 'prepare2fa',
  ACTIVE_2FA: 'active2fa',
  DEACTIVE_2FA: 'deactive2fa',
  SAVE_EMAIL: 'saveEmail',
  SAVE_LANGUAGE: 'saveLanguage',
  SAVE_PASSWORD: 'savePassword',
  SAVE_PERSONAL_SETTINGS: 'savePersonalSettings',
  SAVE_PROFILE_PICTURE: 'saveProfilePicture',
  UNREGISTER_DEVICES: 'unregisterDevice',
  REMOVE_PROFILE_PICTURE: 'removeProfilePicture'
}
